import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { getGetQuotesFormUrl } from '../utils/url';
import PostcodeAutocomplete from 'hui/dist/js/components/autocomplete/postcode-autocomplete';

const $ = window.jQuery;
const RWD = require('../../../hui_core/scripts/components/responsive');

const rwd = new RWD({
  app: window.document
});

export default class PostcodeSearch extends Component {
  static propTypes = { // eslint-disable-line
    classPrefix: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    valueStacked: PropTypes.string,
    placeholder: PropTypes.string,
    GACategory: PropTypes.string,
    GAAction: PropTypes.string,
    GALabel: PropTypes.string
  };

  static defaultProps = { // eslint-disable-line 
    classPrefix: 'hero__directory-postcode',
    name: 'w',
    value: '',
    valueStacked: '',
    placeholder: 'Enter postcode',
    GACategory: '',
    GAAction: '',
    GALabel: ''
  };

  state = { // eslint-disable-line
    postcodeValue: '',
    viewportWidth: ''
  };


  componentDidMount() {
    $(window).on('browserResized', () => {
      this.getPostcodeValue(rwd);
    });
  }

  componentWillUnmount() {
    $(window).on('browserResized', () => {
      this.getPostcodeValue(rwd);
    });
  }

  onChange = (postcodeValue) => { // eslint-disable-line
    this.setState({ postcodeValue });
  };

  onSuggestionSelected = (event, { suggestion }) => { // eslint-disable-line
    const postcodeValue = `${suggestion.postcode} - ${suggestion.suburb}`;
    this.setState({ postcodeValue });
    if (this.props.GACategory && this.props.GAAction && this.props.GALabel) {
      this.onTrackEvent(this.props.GACategory, this.props.GAAction, this.props.GALabel);
    }
    this.formSubmit(event, postcodeValue);
  };

  onTrackEvent = (gaCategory, gaAction, gaLabel) => { // eslint-disable-line
    if (this.props.GACategory && this.props.GAAction && this.props.GALabel) {
      window.pageTracker._trackEvent(gaCategory, gaAction, gaLabel); // eslint-disable-line no-underscore-dangle
    }
  };

  getPostcodeValue = (rwd) => { // eslint-disable-line
    let postcodeValue;
    if (rwd.position.w < 1200 && this.props.valueStacked) {
      postcodeValue = this.props.valueStacked;
    } else {
      postcodeValue = this.props.value;
    }
    this.setState({ postcodeValue });
  };

  UNSAFE_componentWillMount() { // eslint-disable-line camelcase
    this.getPostcodeValue(rwd);
  }

  formSubmit(event, value) {
    event.preventDefault();
    if (window.isModalFormTest) {
      const element = document.getElementById('gqModal');
      const category = window.catObj || undefined;
      window.GQModal.open(element, category, value);
      document.getElementByClassName('hero__gq-postcode__input').blur();
    } else {
      // getGAEventTrackingCode(gaCategory, `${gaAction} Form Submit Hero - PPC`, `${gaLabel} Form Submit Hero - PPC`);
      const formPath = document.getElementById('heroGetQuotes').getAttribute('action');
      window.location.href = getGetQuotesFormUrl(window.location.search, formPath, value);
    }
  }

  render() {
    const { postcodeValue } = this.state;
    return (
      <PostcodeAutocomplete
        classPrefix={this.props.classPrefix}
        value={postcodeValue}
        data-placeholder={this.props.placeholder}
        placeholder={this.props.placeholder}
        onChange={this.onChange}
        onSuggestionSelected={this.onSuggestionSelected}
        autoFocus
        name={this.props.name}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./get-quotes/scripts/components/postcode-autocomplete.js